import { createGlobalStyle } from "styled-components";
import { aaaCustomColors } from "./aaaCustomColors";

export const aaaGlobalCSS = createGlobalStyle`
    body {
        font-family: Inter;
    }

    h1, .h1 {
        font-family: Inter;
        color: ${aaaCustomColors.headingsDark};
        font-size: 80px;
        font-weight: 700;
        line-height: 97px;
    } 

    h2, .h2 {
        font-family: Inter;
        color: ${aaaCustomColors.headingsDark};
        font-size: 50px;
        font-weight: 700;
        line-height: 49px;
    }

    h3, .h3 {
        font-family: Inter;
        color: ${aaaCustomColors.headingsDark};
        font-size: 24px;
        font-weight: 700;
        line-height: 29px;
    }

    p, .body1 {
        font-family: Inter;
        color: ${aaaCustomColors.body1Dark};
        font-size: 16px;
        font-weight: 400;
        line-height: 27px;
    }

    .body1semibold {
        font-family: Inter;
        color: ${aaaCustomColors.body1Dark};
        font-size: 16px;
        font-weight: 600;
        line-height: 27px;
    }

    .body2 {
        font-family: Inter;
        color: ${aaaCustomColors.body2Dark};
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
    }

    .body2semibold {
        font-family: Inter;
        color: ${aaaCustomColors.body2Dark};
        font-size: 14px;
        font-size: 12px;
        font-weight: 600;
        line-height: 20px;
    }

    .caption {
        font-family: Inter;
        color: ${aaaCustomColors.body1Dark};
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
    }

    .applicationDateChip {
        color: ${aaaCustomColors.body1Dark}; //TODO: If confirmed, put in shade of jobCategory
        background-color: ${aaaCustomColors.fieldBackgroundColor};
        border:  "none";
    }

    .kanbanColumnHeader {
        background-color: ${aaaCustomColors.white};
    }

    .hrBotMultipleButton {
        background-color: ${aaaCustomColors.primary};
        border: none;
        border-radius: 4px;
        color: ${aaaCustomColors.white}
    }

    .historyLine {
        border-bottom: 1px solid ${aaaCustomColors.borderColor}
    }

    .customNumberField {
        background-color: ${aaaCustomColors.fieldBackgroundColor};
        border-bottom: none;
        border-top: none;
    }

    .sideBar {
        border-right: 1px solid ${aaaCustomColors.borderColor};
        background-color: ${aaaCustomColors.fieldBackgroundColor};
    }

    .noteHeader {
        border-bottom: 1px solid ${aaaCustomColors.borderColor};
    }

    .disabled {
        opacity: 0.15;
    }

    .topImageHeader {
        color: ${aaaCustomColors.white}
    }

    .loginSite {
        background-color: ${aaaCustomColors.fieldBackgroundColor}; 
    }

    .notification {
        border-bottom: 1px solid ${aaaCustomColors.borderColor};
    }

    .commentsContainer {
        background-color: ${aaaCustomColors.fieldBackgroundColor};
    }

    .comment {
        border-bottom: 1px solid ${aaaCustomColors.middleGrey};
    }
`;
